import http from '@/support/plugin/axios'

export const 

getGeneralOffersByCompanyIdAndCurrentContactId = ( companyId, findGeneral ) => http.get(`companies/${companyId}/contacts/current/offers?general=${findGeneral}`),

getExclusiveOffersByCompanyIdAndCurrentContactId = ( companyId, findExclusive ) => http.get(`companies/${companyId}/contacts/current/offers?exclusive=${findExclusive}`),

getOfferInfoRedeems = (companyId, offerId) => http.get(`companies/${companyId}/contacts/current/offers/${offerId}/participants`)
